import { render, staticRenderFns } from "./InputUseNeedsMealTable.vue?vue&type=template&id=a49acf92&lang=pug"
import script from "./InputUseNeedsMealTable.vue?vue&type=script&lang=ts"
export * from "./InputUseNeedsMealTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports